




































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CloseIcon extends Vue {
  @Prop({ default: '12' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: '#E61414' }) readonly color?: string;
}
